import { MiDatePicker } from "@miplatform/components";
import { DATEPICKER_VARIANTS, INPUT_TYPES } from "@miplatform/constants";

export const dashboardDetailSet = (edit) => {
  return [
    {
      label: "Builder",
      name: "builder",
      fieldType: INPUT_TYPES.TEXTBOX,
      readOnly: true,
      width: "25%",
    },
    {
      label: "Community",
      name: "community",
      fieldType: INPUT_TYPES.TEXTBOX,
      readOnly: true,
      width: "25%",
    },
    {
      label: "Closing Date",
      name: "closingDate",
      fieldType: INPUT_TYPES.CUSTOM,
      customComponent: (
        <MiDatePicker
          label="Closing Date"
          readOnly
          isFullWidth
          isShrink
          variant={DATEPICKER_VARIANTS.DESKTOP}
        />
      ),
      width: "25%",
    },
    {
      label: "Warranty End Date",
      name: "warrantyEndDate",
      fieldType: INPUT_TYPES.CUSTOM,
      customComponent: (
        <MiDatePicker
          label="Warranty End Date"
          readOnly
          isFullWidth
          isShrink
          variant={DATEPICKER_VARIANTS.DESKTOP}
        />
      ),
      width: "25%",
    },
    {
      label: "City",
      name: "city",
      value: edit.getValue("cityName") || "",
      readOnly: true,
      width: "25%",
    },
    {
      label: "County",
      name: "county",
      fieldType: INPUT_TYPES.TEXTBOX,
      readOnly: true,
      width: "25%",
    },
    {
      label: "State",
      name: "regionCode",
      readOnly: true,
      width: "25%",
    },
    {
      label: "Zip Code",
      name: "postalCode",
      fieldType: INPUT_TYPES.NUMBER,
      readOnly: true,
      width: "25%",
    },
    {
      label: "Latitude",
      name: "latitude",
      value: edit.getValue("latitude"),
      fieldType: INPUT_TYPES.NUMBER,
      readOnly: true,
      width: "25%",
    },
    {
      label: "Longitude",
      name: "longitude",
      fieldType: INPUT_TYPES.NUMBER,
      value: edit.getValue("longitude"),
      readOnly: true,
      width: "25%",
    },
    {
      label: "Community Latitude",
      name: "communityLocation.Latitude",
      fieldType: INPUT_TYPES.TEXTBOX,
      value: edit.getValue("communityLocation.Latitude")?.toFixed(5),
      readOnly: true,
      width: "25%",
    },
    {
      label: "Community Longitude",
      name: "communityLocation.Longitude",
      fieldType: INPUT_TYPES.TEXTBOX,
      value: edit.getValue("communityLocation.Longitude")?.toFixed(5),
      readOnly: true,
      width: "25%",
    },
    {
      label: "Floors",
      name: "floors",
      fieldType: INPUT_TYPES.NUMBER,
      readOnly: true,
      width: "25%",
    },
    {
      label: "Baths",
      name: "empty",
      fieldType: INPUT_TYPES.NUMBER,
      readOnly: true,
      width: "25%",
    },
    {
      label: "Job Number",
      name: "jobNumber",
      fieldType: INPUT_TYPES.TEXTBOX,
      readOnly: true,
      width: "50%",
    },
    {
      label: "empty",
      name: "empty",
      fieldType: INPUT_TYPES.EMPTY_FIELD,
      width: "25%",
    },
    {
      label: "empty",
      name: "empty",
      fieldType: INPUT_TYPES.EMPTY_FIELD,
      width: "25%",
    },
  ];
};
